import { searchPosInArrayObject } from "@helpers/general";

/**
 * Checks if a monetic device with the same designation already exists in a given shop.
 */
export function moneticIsExistInShop(
    el: string,
    data: any,
    tableData: any,
    shopLabel: string
): boolean {
    let res = false;
    let shopData = tableData.data;
    let dataMoneticsShop: any = [];
    if (shopData.length > 0) {
        if (shopData[0][shopLabel] === undefined) {
            dataMoneticsShop = shopData;
        } else {
            let posDataMoneticsShop = searchPosInArrayObject(
                shopData,
                "shopId",
                el
            );
            dataMoneticsShop = shopData[posDataMoneticsShop].subRows;
        }
    }
    for (let i = 0; i < dataMoneticsShop.length; i++) {
        let elt = dataMoneticsShop[i];
        let elmData = data.data[0];
        if (elmData.designation === elt["Désignation"]) {
            res = true;
        }
    }
    return res;
}

/**
 * Filters monetics list by shopId from table data.
 */
export function getListMonetics(
    data: any,
    shopId: string,
    shopLabel: string
): any[] {
    let res: any = [];
    if (data.length > 0) {
        if (data[0][shopLabel] !== undefined) {
            for (let i = 0; i < data.length; i++) {
                const element = data[i];
                for (let j = 0; j < element.subRows.length; j++) {
                    const el = element.subRows[j];
                    if (el.shopId === shopId) {
                        res.push(el);
                    }
                }
            }
        } else {
            res = data;
        }
    }
    return res;
}

/**
 * Checks if a designation already exists in the data (case-insensitive).
 */
export function checkDesignationIfExist(
    designation: string,
    data: any,
    designationLabel: string
): boolean {
    let res = false;
    if (data.length > 0) {
        data.forEach((desData: any) => {
            if (desData[designationLabel] !== undefined)
                if (
                    designation?.toUpperCase().trim() ===
                    desData[designationLabel]?.toUpperCase().trim()
                ) {
                    res = true;
                }
        });
    }
    return res;
}
